import styled from "styled-components";
interface ManualReservationWrapperProps {
  isRTL?: string;
  $isPhone?: boolean;
}

export const ManualReservationWrapper = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'isRTL',
})<ManualReservationWrapperProps>`
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  > div {
    position: fixed;
    top: 0;
    ${(props) => (props.isRTL === "ar" ? "left: 0;" : "right: 0;")}
    min-width: ${({ $isPhone }) => ($isPhone ? "100%" : "500px")};
    width: ${({ $isPhone }) => ($isPhone ? "100%" : "30%")};
    z-index: 999;
    min-height: 100%;
    height: 100dvh;
    background-color: #fff;
    box-shadow: 2px 4px 38px 0px #0000001a;
    padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
    display: flex;
    flex-direction: column;
    gap: ${({ $isPhone }) => ($isPhone ? "10px" : "24px")};
    overflow-y: auto;
    .containerHeader {
      .navigate {
        display: flex;
        justify-content: flex-end;
        button {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: ${({ $isPhone }) => ($isPhone ? "20px" : "25px")};
          color: #435363;
          width: ${({ $isPhone }) => ($isPhone ? "24px" : "30px")};
          height: ${({ $isPhone }) => ($isPhone ? "24px" : "30px")};
          background-color: transparent;
          border: none;
          cursor: pointer;
        }
      }
      .containerInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
        p {
          margin: 0;
          padding: 0;
          color: #261b6a;
          font-weight: 700;
          font-size: ${({ $isPhone }) =>
            $isPhone ? "clamp(12px, 4vw, 18px)" : "clamp(10px, 5vw, 24px)"};
          line-height: 100%;
          letter-spacing: 0%;
          text-transform: uppercase;
        }
      }
    }
    .containerTabs {
      button {
        background-color: transparent;
        border: none;
        padding: ${({ $isPhone }) => ($isPhone ? "6px 8px" : "8px 12px")};
        cursor: pointer;
        font-weight: 700;
        font-size: ${({ $isPhone }) => ($isPhone ? "12px" : "14px")};
        line-height: ${({ $isPhone }) => ($isPhone ? "16px" : "20px")};
        letter-spacing: 0%;
        color: #8e98a1;
        &.activeButton {
          background-color: #eeebff;
          color: #364152;
          border-radius: 8px;
        }
      }
    }
  }
`;
